import { create } from 'zustand';

export type SpeedFactor = 1 | 10 | 100 | 1000 | 10000;

interface TimelineState {
  tJd: number;
  speed: SpeedFactor;
  playing: boolean;
  startJd: number;
  stopJd: number;
  set: (t: number) => void;
  setSpeed: (s: SpeedFactor) => void;
  togglePlay: () => void;
  reset: () => void;
  /** Avance la timeline de `dtSeconds * speed` jours, clampé sur [start, stop]. */
  advance: (dtSeconds: number) => void;
}

const NOW_JD = 2461000.5; // ≈ 2026-01-01

export const useTimeline = create<TimelineState>((set, get) => ({
  tJd: NOW_JD,
  speed: 1,
  playing: false,
  startJd: NOW_JD - 365 * 5,
  stopJd: NOW_JD + 365 * 25,
  set: (t) => set({ tJd: t }),
  setSpeed: (s) => set({ speed: s }),
  togglePlay: () => set((s) => ({ playing: !s.playing })),
  reset: () => set({ tJd: NOW_JD, playing: false, speed: 1 }),
  advance: (dtSeconds) => {
    const s = get();
    if (!s.playing) return;
    // 1 seconde de wall-time = `speed` jours simulés.
    let next = s.tJd + dtSeconds * s.speed;
    if (next >= s.stopJd) {
      next = s.stopJd;
      set({ tJd: next, playing: false });
      return;
    }
    if (next <= s.startJd) {
      next = s.startJd;
      set({ tJd: next, playing: false });
      return;
    }
    set({ tJd: next });
  },
}));
